<template class="full-height">
  <div class="app-container" style="position: relative; height: 100%; padding: 15px">
    <el-dialog
      v-if="currentItineraryPlanningRow && currentItineraryPlanningRow.theDay"
      :top="dialogTopMargin"
      :title="'行程規劃資料'"
      :visible.sync="currentItineraryPlanningRowVisible"
      width="85%"
    >
      <el-card>
        <div slot="header" class="clearfix">
          <span>行程設定</span>

          <el-button
            style="float: right; padding: 6px 15px; margin-left: 10px"
            type="danger"
            @click="currentItineraryPlanningRowVisible = false"
            >關 閉</el-button
          >
        </div>

        <el-tabs v-model="planningTab" type="border-card">
          <el-tab-pane label="精彩行程" name="thisTimes" v-if="currentItineraryPlanningRow.theDay">
            <el-col :span="12">
              <el-form
                class="itinerary"
                :disabled="true"
                label-width="130px"
                size="mini"
                label-position="right"
              >
                <el-form-item label="出發時間">
                  <el-time-select
                    v-model="currentItineraryPlanningRow.theDay.departureTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="出發時間"
                  >
                  </el-time-select>
                </el-form-item>
                <el-form-item label="出發集合地點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.assemblingPlace" />
                </el-form-item>

                <el-form-item label="旅館名稱">
                  <el-input v-model="currentItineraryPlanningRow.theDay.hotelName" />
                </el-form-item>

                <el-form-item label="上午景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.morningSights" />
                </el-form-item>

                <el-form-item label="下午景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.afternoonAttractions" />
                </el-form-item>

                <el-form-item label="早餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.breakfast" />
                </el-form-item>

                <el-form-item label="午餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.lunch" />
                </el-form-item>

                <el-form-item label="晚餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.dinner" />
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form
                class="itinerary"
                :disabled="true"
                label-width="130px"
                size="mini"
                label-position="right"
              >
                <el-form-item label="晚間景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.eveningAttractions" />
                </el-form-item>

                <el-form-item label="預計返回旅館時間">
                  <el-time-select
                    v-model="currentItineraryPlanningRow.theDay.returnHotelTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="預計返回旅館時間"
                  >
                  </el-time-select>
                </el-form-item>

                <el-form-item label="本日行程注意事項">
                  <el-input v-model="currentItineraryPlanningRow.theDay.notesOnToday" />
                </el-form-item>

                <el-form-item label="行程手冊上傳"> </el-form-item>
              </el-form>
            </el-col>
          </el-tab-pane>
          <el-tab-pane label="行程規劃" name="thisDays" v-if="currentItineraryPlanningRow.thisTime">
            <div style="overflow-y: scroll; height: 500px">
              <el-form
                class="itinerary"
                :disabled="true"
                v-for="(item, index) in currentItineraryPlanningRow.thisTime.data"
                :key="index"
                :inline="true"
                size="mini"
              >
                <el-form-item label="" size="mini">
                  <el-tag>Day{{ index + 1 }}</el-tag>
                </el-form-item>

                <el-form-item label="行程說明" style="width: 90%" class="widh-input">
                  <el-col class="line" :span="24">
                    <el-input
                      v-model="item.description"
                      style="width: 100%"
                      placeholder="行程說明"
                    />
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>

    <el-dialog
      v-if="
        currentPositionData && currentPositionData.records && currentPositionData.records.length > 0
      "
      :title="'定位足跡紀錄'"
      :visible.sync="positionDialogVisible"
      top="2%"
      width="70%"
    >
      <div style="position: relative; height: 100%; padding: 10px">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="currentPositionData.records"
          border
          fit
          highlight-current-row
          height="600px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="日期" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.date }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="景點" width="250">
            <template slot-scope="scope">
              <span>{{ scope.row.viewPointName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="到達時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="離開時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.leaveTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="停留時間" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.dwellTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="北緯" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lat" type="success">{{ scope.row.lat }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="東經" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lng" type="success">{{ scope.row.lng }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="功能" width="300">
            <template slot-scope="scope" v-if="scope.row.lat && scope.row.lng">
              <el-row>
                <el-col :span="12">
                  <el-button
                    size="mini"
                    @click="googleMap(scope.row)"
                    icon="el-icon-position"
                    type="success"
                    >查看Google地圖</el-button
                  ></el-col
                >
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      v-if="currentChatData && currentChatData.charMsgInfos.length > 0"
      :title="'與領隊聊天紀錄'"
      :visible.sync="chatDialogVisible"
      top="2%"
      width="450px"
    >
      <div
        style="position: relative; height: 100%; padding: 10px"
        v-if="currentChatData.leaderInfo"
      >
        <div class="center">
          <div class="chat">
            <div class="contact bar">
              <div
                class="pic"
                :style="{
                  backgroundImage: 'url(' + currentChatData.leaderInfo.avatar + ')',
                }"
              ></div>
              <div class="name">{{ currentChatData.leaderInfo.name }}</div>
              <div class="seen">{{ currentChatData.date }}</div>
            </div>
            <div class="messages" id="chat">
              <div class="time">聊天紀錄</div>
              <template v-for="(item, index) in currentChatData.charMsgInfos">
                <!-- chat-user 旅客  chat-leader 領隊 -->
                <div
                  style="position: relative"
                  :class="{
                    message: true,
                    'chat-user': item.from != currentChatData.leaderInfo.name,
                    'chat-leader': item.from == currentChatData.leaderInfo.name,
                  }"
                  :key="index"
                >
                  <i
                    v-if="item.from != currentChatData.leaderInfo.name"
                    class="chat-time-chat-user"
                    >{{ item.time }}</i
                  >

                  <span v-if="item.chatType == 1"></span> {{ item.msg }}
                  <template v-if="item.chatType == 2">
                    <el-image
                      v-if="item.fileInfo"
                      style="width: 80px"
                      :src="item.fileInfo.url"
                      fit="fill"
                      :preview-src-list="[item.fileInfo.url]"
                    ></el-image>
                    <span v-else>圖片加載失敗</span>
                  </template>
                  <i
                    v-if="item.from == currentChatData.leaderInfo.name"
                    class="chat-time-chat-leader"
                    >{{ item.time }}</i
                  >
                </div>
              </template>
            </div>
            <div class="input">
              <i class="fas fa-camera"></i><i class="far fa-laugh-beam"></i>
              {{
                `【${currentChatData.userInfo.name}】與【${currentChatData.leaderInfo.name}】領隊聊天紀錄`
              }}
              <!-- <input placeholder="Type your message here!" type="text" /> -->
              <i class="fas fa-microphone"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 說明會影片 -->
    <el-dialog
      :top="dialogTopMargin"
      :title="'說明會影片'"
      :visible.sync="seminarMovieDialogVisible"
      width="50%"
    >
      <div style="text-align: center; width: 100%">
        <video :src="currentSeminarMovieUrl" autoplay controls></video>
      </div>
    </el-dialog>
    <!-- 資料查看 -->
    <el-dialog
      v-if="currentRow"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'資料查看'"
      :visible.sync="viewDataDialogVisible"
      width="60%"
    >
      <el-row>
        <el-col :span="currentRow.applyType == 1 ? 24 : currentRow.applyType == 1 ? 12 : 24">
          <el-alert
            v-if="currentRow && currentRow.applyType != 8"
            :title="`自${currentRow.applyDates[0]}至${currentRow.applyDates[1]}，申請【${currentRow.applyTypeDesc}】資料共計：${viewData.length} 筆`"
            :closable="false"
            type="warning"
            effect="dark"
            style="color: #4b4b4b; margin-bottom: 10px"
          >
          </el-alert>
          <div style="position: relative; height: 80%">
            <div v-if="currentRow.applyType == 8">
              <el-tag type="success" style="margin: 5px">審核說明</el-tag>
              <el-input
                :disabled="true"
                type="textarea"
                :rows="20"
                style="height: 20%"
                :value="successRemark"
              ></el-input>
            </div>
            <!-- 公告訊息更改紀錄 -->
            <el-table
              v-if="currentRow.applyType == 1"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="時間" width="180">
                <template slot-scope="scope">
                  {{ scope.row.buildDate }}
                  <!-- <el-tag>{{ scope.row.buildDate }}</el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="建立者" width="130">
                <template slot-scope="scope">
                  {{ scope.row.buildUserName }}
                  <!-- <el-tag>{{ scope.row.buildUserName }}</el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="公告內容">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.data.bulletinBoard">{{
                    scope.row.data.bulletinBoard | cuttingText
                  }}</el-tag>
                  <el-tag v-else :type="'danger'">無內容</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="查看" width="120">
                <template slot-scope="scope">
                  <el-button
                    v-if="currentRow.applyType == 1 && scope.row.data.bulletinBoard"
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(currentRow, scope.row.data.bulletinBoard)"
                    :disabled="false"
                    >查看內容</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 攜帶物品資料 -->
            <el-table
              v-if="currentRow.applyType == 2"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="時間" width="180">
                <template slot-scope="scope">
                  {{ scope.row.buildDate }}
                  <!-- <el-tag>{{ scope.row.buildDate }}</el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="建立者">
                <template slot-scope="scope">
                  {{ scope.row.buildUserName }}
                  <!-- <el-tag>{{ scope.row.buildUserName }}</el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="建議攜帶物品" width="300">
                <template slot-scope="scope">
                  <el-button
                    v-if="currentRow.applyType == 2"
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >查看攜帶物品紀錄</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 說明會上傳紀錄 -->
            <el-table
              v-if="currentRow.applyType == 3"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="時間" width="180">
                <template slot-scope="scope">
                  {{ scope.row.buildDate }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="建立者">
                <template slot-scope="scope">
                  {{ scope.row.buildUserName }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="查看說明會影片" width="300">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      currentRow.applyType == 3 &&
                      scope.row.data.fileInfo &&
                      scope.row.data.fileInfo.length > 0 &&
                      scope.row.data.fileInfo[0].files &&
                      scope.row.data.fileInfo[0].files.length > 0
                    "
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >查看說明會影片</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 領隊聊天紀錄 -->
            <el-table
              v-if="currentRow.applyType == 4"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="日期">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.date }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="查看聊天紀錄" width="400">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.charMsgInfos.length > 0"
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >查看與領隊聊天紀錄</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 導覽對話紀錄 -->
            <el-table
              v-if="currentRow.applyType == 5"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="日期" width="120">
                <template slot-scope="scope">
                  {{ scope.row.date }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="時間" width="180">
                <template slot-scope="scope">
                  {{ scope.row.time }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="檔名" width="300">
                <template slot-scope="scope">
                  {{ scope.row.fileName }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="大小" width="110">
                <template slot-scope="scope">
                  {{ scope.row.size }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="查看導覽紀錄" width="200">
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-video-play"
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >點我播放</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 定位足跡紀錄 -->
            <el-table
              v-if="currentRow.applyType == 6"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="日期">
                <template slot-scope="scope">
                  {{ scope.row.date }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="景點數量" width="120">
                <template slot-scope="scope">
                  <el-tag type="danger">{{ scope.row.records.length }}</el-tag>
                  個景點
                </template>
              </el-table-column>

              <el-table-column align="center" label="查看足跡紀錄" width="300">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 每日行程文字紀錄 -->
            <el-table
              v-if="currentRow.applyType == 7"
              v-loading="listLoading"
              size="mini"
              :data="viewData"
              border
              fit
              highlight-current-row
              height="550px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="時間" width="180">
                <template slot-scope="scope">
                  {{ scope.row.buildDate }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="建立者">
                <template slot-scope="scope">
                  {{ scope.row.buildUserName }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="每日行程" width="300">
                <template slot-scope="scope">
                  <el-button
                    v-if="currentRow.applyType == 7"
                    type="primary"
                    size="mini"
                    @click="viewReferenceData(scope.row)"
                    :disabled="false"
                    >查看每日行程</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="viewDataDialogVisible = false">關 閉</el-button>
      </div>
    </el-dialog>
    <!-- 攜帶物品異動紀錄 -->
    <el-dialog
      v-if="currentCarryRow"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'攜帶物品異動紀錄'"
      :visible.sync="carryDialogVisible"
      width="60%"
    >
      <el-row>
        <el-col :span="12" style="padding-right: 5px">
          <div style="position: relative; height: 80%">
            <el-alert type="success" style="margin-bottom: 10px" :closable="false">{{
              `建議攜帶物品共 ${currentCarryRow.data.recommended.items.length} 項`
            }}</el-alert>
            <!-- 公告資料 -->
            <el-table
              v-if="currentCarryRow.applyType == 2"
              size="mini"
              :data="currentCarryRow.data.recommended.items"
              border
              fit
              highlight-current-row
              height="600px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="品項">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <el-col :span="12" style="padding-left: 5px">
          <div style="position: relative; height: 80%">
            <el-alert type="error" style="margin-bottom: 10px" :closable="false">{{
              `必帶物品共 ${currentCarryRow.data.required.items.length} 項`
            }}</el-alert>
            <!-- 公告資料 -->
            <el-table
              v-if="currentCarryRow.applyType == 2"
              size="mini"
              :data="currentCarryRow.data.required.items"
              border
              fit
              highlight-current-row
              height="600px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="品項">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <!-- currentCarryRow.data.required.items
    currentCarryRow.data.recommended.items -->
    </el-dialog>

    <el-dialog
      v-loading="dialogLoading"
      :top="'3%'"
      :title="'作業紀錄'"
      :visible.sync="logDialogVisible"
      width="75%"
    >
      <div style="position: relative; height: 80%">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="logs"
          border
          fit
          highlight-current-row
          height="500px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="日期" width="220">
            <template slot-scope="{ row }">
              <span>{{ row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.beforeStatus | statusFilter">{{
                scope.row.beforeStatusDesc
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態(異)" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status | statusFilter">{{ scope.row.statusDesc }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="備註">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="作業人員" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.buildUserName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="logDialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>
    <!-- 紀錄資訊需求維護 -->
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form
          ref="form"
          :model="form"
          :label-width="formLabelWidth"
          :disabled="form.status == 0 || form.status == 3 || form.status == 4 ? false : true"
        >
          <el-form-item v-if="form.id" :label="'狀態'">
            <el-tag :type="form.status | statusFilter">{{ form.statusDesc }}</el-tag>

            <el-tag v-if="form.status == 0" type="danger">表單審核中，無法修改。</el-tag>
          </el-form-item>

          <el-form-item
            :label="'申請項目'"
            prop="applyType"
            :rules="[
              {
                required: true,
                message: '請選擇申請項目',
                trigger: 'change',
              },
            ]"
          >
            <el-select
              @change="getTravelDateRangeInfoByTourNo"
              style="width: 100%"
              v-model="form.applyType"
              clearable
              placeholder="請選擇項目"
            >
              <el-option
                v-for="item in applyOptions"
                :key="item.key"
                :label="`${item.val}`"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="'資訊需求團號'"
            prop="applyTourNo"
            :rules="[
              {
                required: true,
                message: '請填寫紀錄資訊需求團號',
                trigger: 'change',
              },
            ]"
          >
            <el-row v-if="!form.status">
              <el-tag
                type="warning"
                style="height: auto; white-space: break-spaces; font-size: 14px"
                >選取後預設帶入班機起飛/回程時間</el-tag
              >
            </el-row>
            <el-select
              @change="getTravelDateRangeInfoByTourNo"
              style="width: 100%"
              v-if="tourNumbers.length > 0"
              v-model="form.applyTourNo"
              clearable
              placeholder="請選擇團號"
            >
              <el-option
                v-for="item in tourNumbers"
                :key="item.key"
                :label="`${item.val}`"
                :value="item.key"
              >
              </el-option>
            </el-select>
            <!--
            <span v-if="!form.status" style="color: blue"
              >選取後預設帶入班機起飛/回程時間</span
            > -->
          </el-form-item>

          <el-form-item
            :label="'資訊需求日期時間範圍'"
            prop="applyDates"
            :rules="[
              {
                required: true,
                message: '請選擇資訊需求日期時間範圍',
                trigger: 'change',
              },
            ]"
          >
            <el-row v-if="!form.status">
              <el-tag
                type="warning"
                style="height: auto; white-space: break-spaces; font-size: 14px"
                >日期一律以台灣時間為基準</el-tag
              >
            </el-row>
            <el-date-picker
              v-loading="dateInfoLoading"
              :picker-options="pickerOptions"
              :disabled="!form.applyTourNo"
              style="width: 100%"
              v-model="form.applyDates"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
            >
            </el-date-picker>

            <!-- <span v-if="!form.status" style="color: blue"
              >日期一律以台灣時間為基準</span
            > -->
          </el-form-item>
          <!--
          <el-form-item
            :label="'資訊需求時間'"
            prop="applyTime"
            :rules="[
              {
                required: true,
                message: '請填寫紀錄資訊需求時間',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="form.applyTime"></el-input>
          </el-form-item> -->

          <el-form-item
            v-if="showUserOptionsApplyTypeIDs.includes(form.applyType)"
            :label="'資訊需求人物姓名'"
            prop="applyUserID"
            :rules="[
              {
                required: showUserOptionsApplyTypeIDs.includes(form.applyType) ? true : false,
                message: '請填寫紀錄資訊需求人物姓名',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-loading="dateInfoLoading"
              style="width: 100%"
              v-model="form.applyUserID"
              clearable
              placeholder="請選擇旅客"
            >
              <el-option
                v-for="item in travelers"
                :key="item.userID"
                :label="`${item.name}`"
                :value="item.userID"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            prop="applyDescription"
            :label="'發生經過'"
            :rules="[
              {
                required: true,
                message: '請詳細填寫發生經過，以及需求何種紀錄為參考依據',
                trigger: 'blur',
              },
            ]"
          >
            <div>
              <span>請詳細填寫發生經過，以及需求何種紀錄為參考依據。</span>
              <el-input
                id="remarkAreaContent"
                type="textarea"
                :rows="10"
                v-model="form.applyDescription"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          @click="saveData"
          style="color: #4b4b4b"
          v-if="form.status == 0 || form.status == 3 || form.status == 4"
          >儲 存</el-button
        >

        <el-button @click="cancelRecordRequestStatus" v-if="form.status == 1">取消申請</el-button>
        <el-button
          @click="dialogVisible = false"
          :type="form.status == 0 || form.status == 3 || form.status == 4 ? '' : 'danger'"
          >{{
            form.status == 0 || form.status == 3 || form.status == 4 ? '取 消' : '關 閉'
          }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 客服mobile -->
    <el-dialog
      v-if="device == 'mobile'"
      :top="dialogTopMargin"
      :title="'客服訊息'"
      :visible.sync="dialogMessageVisible"
      fullscreen
      v-loading="chatLoading"
      class="customerDialog"
    >
      <el-card
        class="box-card chat-window full-height"
        :body-style="{ height: '88%', 'overflow-y': 'scroll' }"
      >
        <div slot="header" class="clearfix">
          <span>{{ toUser.userName }}</span>
        </div>
        <template v-if="filtered_list.length > 0">
          <div v-for="(item, index) in filtered_list[0].messages" :key="index">
            <el-row>
              <el-col :span="24"
                ><div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <div class="chat-container-from" v-if="d.from != fromUser">
                    <div>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          :preview-src-list="[d.fileInfo.url]"
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                        ></el-image>
                      </span>
                      <i class="time-flag"> {{ d.time }}</i>
                    </div>
                  </div>
                  <div
                    style="text-align: right"
                    class="chat-container-send"
                    v-if="d.from == fromUser"
                  >
                    <div>
                      <i v-if="d.isRead" class="read-flag">已讀</i>
                      <i class="time-flag">{{ d.time }}</i>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                          :preview-src-list="[d.fileInfo.url]"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-card>

      <el-input
        :disabled="chatLoading"
        style="width: 100%"
        v-model="msg"
        placeholder="請輸入內容"
        @keyup.enter.native="sendMsg"
      >
        <!-- <el-button
    :disabled="chatLoading"
    slot="prepend"
    type="success"
    icon="el-icon-plus"
  ></el-button> -->

        <!-- <Upload
    slot="prepend"
    ref="uploadCommonFormsRef"
    :accept="'.img,.jpg,.png,.jpeg,.bmp'"
    :payload="{ from: fromUser, to: toUser.userAccount }"
    :data-obj="fileObj"
    :limit-file-count="20"
    :use-drag="false"
    :action="'Chat'"
    :auto-upload="true"
    :show-file-list="false"
    :btn-txt="'上傳'"
    :before-file-list="[]"
    :show-limit="false"
    :sendFileMsgCallback="sendFileMsg"
  /> -->

        <el-button
          :disabled="chatLoading"
          slot="append"
          icon="el-icon-s-promotion"
          type="success"
          @click="sendMsg"
        />
      </el-input>
    </el-dialog>

    <el-tabs type="border-card" v-model="currentTab" @tab-click="handleClick" style="height: 100%">
      <el-tab-pane label="客服" name="1">
        <div class="full-height">
          <div style="position: relative; height: 90%" v-loading="listLoading">
            <el-row class="row-box full-height">
              <el-col class="full-height" :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                <el-table
                  size="mini"
                  :data="customerComplaintList"
                  border
                  style="width: 100%"
                  height="100%"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="團號">
                    <template slot-scope="{ row }">
                      <span>{{ row.tourGroupNo }}</span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column align="center" label="團名">
                    <template slot-scope="{ row }">
                      <span>{{ row.travelName }}</span>
                      <div>
                        <el-tag>
                          出發{{ `${row.beginDate}` }} - 回程{{
                            `${row.endDate}`
                          }}
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column> -->

                  <el-table-column align="center" label="團名">
                    <template slot-scope="{ row }">
                      <span>{{ row.travelName }}</span>
                      <div>
                        <el-tag style="font-size: 14px">
                          出發
                          <span style="color: red">{{ `${row.beginDate}` }}</span>
                          - 回程
                          <span style="color: red">{{ `${row.endDate}` }}</span>
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="APP使用者">
                    <template slot-scope="{ row }">
                      <span>{{ row.fromUserName }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看內文">
                    <template slot-scope="scope">
                      <el-button size="mini" type="info" @click="editCustomerComplaint(scope.row)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col
                v-if="device == 'desktop'"
                class="full-height hidden-xs-only"
                v-loading="chatLoading"
                :span="9"
                :offset="1"
                style="position: relative; height: 92%"
              >
                <el-card
                  class="box-card chat-window full-height"
                  :body-style="{ height: '88%', 'overflow-y': 'scroll' }"
                >
                  <div slot="header" class="clearfix">
                    <span>{{ toUser.userName }}</span>
                  </div>
                  <template v-if="filtered_list.length > 0">
                    <div v-for="(item, index) in filtered_list[0].messages" :key="index">
                      <el-row>
                        <el-col :span="24"
                          ><div class="chat-date">
                            <el-tag>{{ item.date }}</el-tag>
                          </div></el-col
                        >
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div
                            class="chat-receive"
                            v-for="(d, ind) in item.charMsgInfos"
                            :key="ind"
                          >
                            <div class="chat-container-from" v-if="d.from != fromUser">
                              <div>
                                <span
                                  v-if="d.chatType == 1"
                                  :closable="false"
                                  class="chat-content-form"
                                >
                                  {{ d.msg }}
                                </span>
                                <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                                  <el-image
                                    :preview-src-list="[d.fileInfo.url]"
                                    style="width: 100px; height: 100px"
                                    :src="d.fileInfo.url"
                                    :fit="'cover'"
                                  ></el-image>
                                </span>
                                <i class="time-flag"> {{ d.time }}</i>
                              </div>
                            </div>
                            <div
                              style="text-align: right"
                              class="chat-container-send"
                              v-if="d.from == fromUser"
                            >
                              <div>
                                <i v-if="d.isRead" class="read-flag">已讀</i>
                                <i class="time-flag">{{ d.time }}</i>
                                <span
                                  v-if="d.chatType == 1"
                                  :closable="false"
                                  class="chat-content-send"
                                >
                                  {{ d.msg }}
                                </span>
                                <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                                  <el-image
                                    style="width: 100px; height: 100px"
                                    :src="d.fileInfo.url"
                                    :fit="'cover'"
                                    :preview-src-list="[d.fileInfo.url]"
                                  ></el-image>
                                </span>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                </el-card>

                <el-input
                  :disabled="chatLoading"
                  style="width: 100%"
                  v-model="msg"
                  placeholder="請輸入內容"
                  @keyup.enter.native="sendMsg"
                >
                  <!-- <el-button
                :disabled="chatLoading"
                slot="prepend"
                type="success"
                icon="el-icon-plus"
              ></el-button> -->

                  <!-- <Upload
                slot="prepend"
                ref="uploadCommonFormsRef"
                :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                :payload="{ from: fromUser, to: toUser.userAccount }"
                :data-obj="fileObj"
                :limit-file-count="20"
                :use-drag="false"
                :action="'Chat'"
                :auto-upload="true"
                :show-file-list="false"
                :btn-txt="'上傳'"
                :before-file-list="[]"
                :show-limit="false"
                :sendFileMsgCallback="sendFileMsg"
              /> -->

                  <el-button
                    :disabled="chatLoading"
                    slot="append"
                    icon="el-icon-s-promotion"
                    type="success"
                    @click="sendMsg"
                  />
                </el-input>
              </el-col>
            </el-row>

            <pagination
              v-show="cctotal > 0"
              layout="prev, pager, next"
              :total="cctotal"
              :page.sync="listQueryCC.page"
              :limit.sync="listQueryCC.limit"
              @pagination="getAgencyCustomerComplaint"
            />
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="紀錄資訊需求" name="2">
        <div class="full-height">
          <!-- <div style="padding: 20px; padding-bottom: 0">
              <el-form :inline="true">
                <el-form-item label="查詢">
                  <el-input
                    v-model="listQuery.qry"
                    placeholder="輸入需求人姓名或旅遊團名稱"
                  />
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="getList">查詢</el-button>
                </el-form-item>

                <el-form-item>
                  <el-button type="success" @click="addData">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    style="cursor: pointer"
                    v-loading="listLoading"
                    type="success"
                    icon="el-icon-refresh-left"
                    circle
                    @click="refresh()"
                  ></el-button>
                </el-form-item>
              </el-form>
            </div> -->
          <el-form :inline="true" class="filter-form" @submit.native.prevent>
            <el-form-item label="查詢">
              <el-input
                v-model="listQuery.qry"
                placeholder="輸入需求人姓名或旅遊團名稱"
                @keyup.enter.native="getList"
              />
            </el-form-item>

            <el-button
              type="primary"
              @click="getList"
              icon="el-icon-search"
              circle
              style="margin-top: 8px; margin-left: 5px"
              :disabled="listLoading"
            ></el-button>
            <el-button
              type="warning"
              @click="addData"
              circle
              icon="el-icon-plus"
              :disabled="listLoading"
            ></el-button>
            <el-button
              style="cursor: pointer"
              type="success"
              :loading="listLoading"
              circle
              icon="el-icon-refresh-left"
              @click="refresh()"
            ></el-button>
          </el-form>

          <div style="position: relative; height: 80%" v-loading="listLoading">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="list"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="申請項目" width="200">
                <template slot-scope="scope">
                  {{ scope.row.applyTypeDesc }}
                  <!-- <el-tag>{{ scope.row.applyTypeDesc }}</el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="狀態" width="130">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status | statusFilter">{{
                    scope.row.statusDesc
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="團號" width="280">
                <template slot-scope="{ row }">
                  <span>{{ row.applyTourNo }}</span>
                  <div>
                    <el-tag>
                      {{ row.applyTravelName }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="需求人姓名" width="130">
                <template slot-scope="scope">
                  <span>{{ scope.row.applyUserName }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="申請時間範圍" width="280">
                <template slot-scope="scope">
                  <span>{{ scope.row.applyBeginDate }} - {{ scope.row.applyEndDate }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="編輯">
                <template slot-scope="scope">
                  <el-button
                    :type="
                      scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4
                        ? 'success'
                        : 'info'
                    "
                    @click="editData(scope.row)"
                    size="mini"
                    >{{
                      scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4
                        ? '編輯'
                        : '查看'
                    }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column align="center" label="紀錄">
                <template slot-scope="scope">
                  <el-button type="primary" @click="getRecordRequestLog(scope.row.id)" size="mini"
                    >紀錄</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" label="資料查看" width="120">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status == 2"
                    type="success"
                    size="mini"
                    @click="getRecordRequestApplyDoneData(scope.row)"
                    >資料查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination
            v-show="total > 0"
            layout="prev, pager, next"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="getList"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const NotSetStatus = 0
const AwaitingStatus = 1
const SuccessStatus = 2
const RejectStatus = 3

import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import { mapGetters } from 'vuex'
import { getTravelDateRangeInfoByTourNo } from '@/api/travel'
import {
  getTourNumbers,
  getRequestApplyOption,
  saveAgencyRecordRequest,
  getAgencyRecordRequestList,
  getAgencyCustomerComplaint,
  deleteAgencyCustomerComplaint,
  markMessageAsReadComplaint,
  saveAgencyCustomerComplaint,
  getUserCustomerComplaintMessage,
} from '@/api/agency'

import {
  modifyRecordRequestStatus,
  getRecordRequestLog,
  getRecordRequestApplyDoneData,
} from '@/api/appManage'

var defaultForm = {
  applyDates: [],
  agencyCode: null,
  applyBeginDate: null,
  applyDescription: null,
  applyEndDate: null,
  applyTourNo: null,
  applyTravelID: null,
  applyTravelName: null,
  applyType: null,
  applyUserID: null,
  applyUserName: null,
  id: null,
  reviewDate: null,
  reviewerUserID: null,
  reviewerUserName: null,
  status: 0,
  statusDesc: '未設定',
}

export default {
  name: 'AgencyRecordRequest',
  components: {
    Pagination,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger',
      }
      return statusMap[status]
    },
    cuttingText(text) {
      return text ? (text.length > 15 ? `${text.substring(0, 20)}...` : text) : ''
    },
  },
  computed: {
    filtered_list() {
      if (this.chatList && this.chatList.length > 0) {
        this.currentCharMessages = this.chatList[0].messages
        return this.chatList
      }
      return []
    },
    ...mapGetters(['account', 'device']),
  },
  data() {
    return {
      currentTab: '1',
      customComplaintList: [],
      successRemark: null,
      showUserOptionsApplyTypeIDs: [4, 6],
      planningTab: 'thisTimes',
      currentItineraryPlanningRow: null,
      currentItineraryPlanningRowVisible: false,
      positionDialogVisible: false,
      currentPositionData: null,
      currentChatData: null,
      chatDialogVisible: false,
      seminarMovieDialogVisible: false,
      currentSeminarMovieUrl: null,
      carryDialogVisible: false,
      currentCarryRow: null,
      currentRow: null,
      viewDataDialogVisible: false,
      logDialogVisible: false,
      dateInfoLoading: false,
      funcName: '紀錄資訊需求',
      dialogTopMargin: '2%',
      formLabelWidth: '180px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        agencyCode: null,
      },
      listQueryCC: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        agencyCode: null,
      },
      cctotal: 0,
      total: 0,
      list: [],
      tourNumbers: [],
      agencyCode: null,
      selectedBeginDate: null,
      selectedEndDate: null,
      travelers: [],
      applyOptions: [],
      logs: [],
      viewData: [],
      pickerOptions: {
        onPick: obj => {
          // console.log("obj", obj); // {maxDate: xxx, minDate: xxx(中国标准时间)}
          this.selectedBeginDate = new Date(obj.minDate).getTime()
          this.selectedEndDate = new Date(obj.maxDate).getTime()
        },
        disabledDate: time => {
          const day1 = 1 * 24 * 3600 * 1000
          let minTime = new Date(this.form.applyDates[0]).getTime()
          let maxTime = new Date(this.form.applyDates[1]).getTime()
          return !(time.getTime() >= minTime - day1 && time.getTime() <= maxTime)
        },
      },
      customerComplaintList: [],
      toUser: {},
      chatList: [],
      currentCharMessages: [],
      msg: '',
      fromUser: '',
      chatLoading: false,
      dialogMessageVisible: false,
    }
  },
  async created() {
    let vm = this
    this.agencyCode = vm.$store.getters.userInfo.agencyCode
      ? vm.$store.getters.userInfo.agencyCode
      : null

    this.listQuery.agencyCode = this.agencyCode
    this.form = defaultForm
  },
  async mounted() {
    this.currentTab = '1'
    await this.handleClick({ name: '1' }, null)
  },
  methods: {
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name == '1') {
        await this.getAgencyCustomerComplaint()
      } else {
        this.listLoading = true
        await this.getRequestApplyOption()
        await this.getTourNumbers()
        await this.getList()
        this.listLoading = false
      }
    },
    async viewReferenceData(row, content) {
      let vm = this
      switch (row.applyType) {
        case 1:
          alert(content)
          break
        case 2: //攜帶物品
          vm.currentCarryRow = row
          vm.carryDialogVisible = true
          break
        case 3: //說明會
          vm.currentSeminarMovieUrl = row.data.fileInfo[0].files[0].url
          vm.seminarMovieDialogVisible = true
          break
        case 4: //聊天紀錄
          vm.chatDialogVisible = true
          vm.currentChatData = row
          break
        case 5: //導覽紀錄
          let link = row.link
          const newWindow = window.open(link)
          newWindow.opener = null
          break
        case 6: //足跡紀錄
          vm.positionDialogVisible = true
          vm.currentPositionData = row
          break
        case 7: //每日行程
          vm.currentItineraryPlanningRow = row.data
          vm.currentItineraryPlanningRowVisible = true
          break
        default:
          break
      }
    },
    async getRecordRequestApplyDoneData(row) {
      let vm = this
      vm.currentRow = row
      let resp = await getRecordRequestApplyDoneData({ id: row.id })
      let applyType = row.applyType
      /*
        apply1 = 1,公告訊息更改紀錄
        apply2 = 2,攜帶物品更改紀錄
        apply3 = 3,領隊上傳說明會影片紀錄
        apply4 = 4,旅客與領隊對話文字紀錄
        apply5 = 5,領隊導覽語音紀錄
        apply6 = 6, 定位歷史紀錄軌跡
        apply7 = 7, 每日行程文字紀錄
      */
      switch (applyType) {
        case 1:
          vm.viewData = resp.data
          break
        case 2:
          vm.viewData = resp.data
          break
        case 3:
          vm.viewData = resp.data
          break
        case 4:
          vm.viewData = resp.data
          break
        case 5:
          vm.viewData = resp.data
          break
        case 6:
          vm.viewData = resp.data
          break
        case 7:
          vm.viewData = resp.data
          break
        case 8:
          vm.successRemark = resp.data
          break
        default:
          break
      }

      vm.viewDataDialogVisible = true
    },
    async getRecordRequestLog(id) {
      let vm = this
      let resp = await getRecordRequestLog({ id })
      if (resp.data && resp.data.length > 0) {
        vm.logs = resp.data
        vm.logDialogVisible = true
      } else {
        alert('尚無紀錄')
      }
    },
    async cancelRecordRequestStatus() {
      if (confirm(`請問確定要取消申請?`)) {
        this.dialogLoading = true
        await modifyRecordRequestStatus({
          id: this.form.id,
          status: 4,
        })
        this.dialogVisible = false
        await this.getList()
        this.dialogLoading = false
      }
    },
    async getRequestApplyOption() {
      let resp = await getRequestApplyOption()
      this.applyOptions = resp.data
    },
    async getTravelDateRangeInfoByTourNo() {
      if (!this.form.applyTourNo) {
        return
      }

      this.dateInfoLoading = true
      let resp = await getTravelDateRangeInfoByTourNo({
        tourNo: this.form.applyTourNo,
        applyType: this.form.applyType,
      })
        .then(response => {
          return response
        })
        .catch(error => {
          return null
        })

      if (resp == null) {
        this.dateInfoLoading = false
        this.form = JSON.parse(JSON.stringify(defaultForm))
        return false
      }
      // let resp = await getTravelDateRangeInfoByTourNo({
      //   tourNo: this.form.applyTourNo,
      //   applyType: this.form.applyType,
      // });

      this.dateInfoLoading = false
      if (resp.data && resp.data.dateInfo) {
        this.form.applyDates = [
          `${resp.data.dateInfo.departureDate} ${resp.data.dateInfo.departureTime}`,
          `${resp.data.dateInfo.returnDate} ${resp.data.dateInfo.returnTime}`,
        ]
      }
      if (!this.form.id) {
        this.form.applyUserID = null
      }

      if (resp.data && resp.data.travelers) {
        this.travelers = resp.data.travelers
      }
    },
    async getTourNumbers() {
      let resp = await getTourNumbers({ agencyCode: this.agencyCode })
      this.tourNumbers = resp.data
    },
    addData() {
      this.form = JSON.parse(JSON.stringify(defaultForm))
      this.dialogVisible = true
    },
    async editData(row) {
      this.form = row
      if (row.id) {
        await this.getTravelDateRangeInfoByTourNo()
      }
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          vm.form.agencyCode = this.agencyCode || ''
          try {
            let resp = await saveAgencyRecordRequest(this.form)
            await vm.getList()
            this.dialogVisible = false
            vm.dialogLoading = false
            Message({
              message: '資料處理完成，請等待審核，謝謝',
              type: 'success',
              duration: 5 * 1000,
            })
          } catch (error) {
            this.dialogVisible = false
            vm.dialogLoading = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getAgencyRecordRequestList(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
    async getAgencyCustomerComplaint() {
      this.listLoading = true
      let resp = await getAgencyCustomerComplaint(this.listQueryCC)
      this.customerComplaintList = resp.data.data
      this.cctotal = resp.data.total
      this.listLoading = false
    },
    async editCustomerComplaint(row) {
      const vm = this
      console.log(row)
      vm.fromUser = row.fromUser
      vm.toUser = {
        userName: row.fromUserName,
        buildUserID: row.buildUserID.toString(),
        fromUser: row.fromUser,
        travelID: row.travelID,
      }
      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }
      vm.chatLoading = true

      // // 建立聊天室並標示訊息已讀
      const payload = {
        from: this.agencyCode,
        to: [row.buildUserID.toString()],
        travelID: this.toUser.travelID,
      }
      markMessageAsReadComplaint(payload).then(async response => {
        //await this.getDirectMessages();
        //response.data 為完整對話紀錄
        vm.chatList = response.data
        //vm.drawer = true;
        vm.chatLoading = false
        // 聊天視窗向底部
        // setTimeout(() => {
        //   vm.updateScrollTop();
        // }, 500);
      })
    },
    async sendMsg() {
      if (!this.msg.trim()) {
        return
      }
      var data = {
        agencyCode: this.agencyCode,
        fromUser: this.toUser.fromUser,
        complaintContent: this.msg,
        travelID: this.toUser.travelID,
      }
      this.chatLoading = true
      await saveAgencyCustomerComplaint(data).then(async resp => {
        await this.getComplaint()
      })
    },
    async getComplaint() {
      const payload = {
        from: this.agencyCode,
        to: [this.toUser.buildUserID],
        travelID: this.toUser.travelID,
      }
      await getUserCustomerComplaintMessage(payload).then(resp => {
        this.chatList = resp.data
        this.chatLoading = false
        this.msg = ''
      })
    },
  },
}
</script>

<style scope>
.customerDialog .el-dialog__body {
  height: 80%;
}
video {
  width: 100%;
  object-fit: fill;
}

.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding: 15px !important;
}
.el-date-range-picker__time-header > span:nth-child(1) > span:nth-child(1) > div > input,
.el-date-range-picker__time-header
  > span.el-date-range-picker__editors-wrap.is-right
  > span:nth-child(1)
  > div
  > input {
  pointer-events: none;
  background-color: #ccc;
}

.view-point-app-container .is-disabled * {
  color: rgb(44, 192, 147) !important;
}

.chat-container-from {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}
.chat-content-form {
  font-size: 12px;
  position: relative;
  background-color: #13ce66;
  color: white;
  padding: 5px;
  width: auto;
  border-radius: 6px;
}

.chat-container-send {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}
.chat-content-send {
  font-size: 12px;
  position: relative;
  /* height: 30px; */
  margin-bottom: 3px;
  background-color: #ff4949;
  color: white;
  padding: 5px;
  width: auto;
  border-radius: 6px;
  word-wrap: break-word;
  word-break: normal;
}

.chat-container-from .time-flag {
  bottom: 0px;
  position: absolute;
  font-size: 12px;
  color: #42443f;
  margin-left: 5px;
}

.chat-container-send .time-flag {
  top: 10px;
  font-size: 12px;
  color: #42443f;
  margin-right: 5px;
}

.el-card-define {
  position: relative;
  /* min-height: 100%;
  height: 100%; */
  height: calc(100vh - 36px);
  min-height: calc(100vh - 36px);
}
.el-card-define >>> .el-card__body {
  position: relative;
  height: 100%;
}

.row-box {
  position: relative;
  height: 100% !important;
}

.el-input-group__append button.el-button {
  background: #42d885;
  border-color: #42d885;
  color: #ffffff;
}

.chat-date {
  text-align: center;
  margin-bottom: 8px;
}

.read-flag {
  font-size: 5px;
  margin-right: 2px;
}

.el-tabs__content {
  position: relative;
  height: 95%;
}
</style>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Red+Hat+Display:400,500,900&display=swap');

body,
html {
  font-family:
    Red hat Display,
    sans-serif;
  font-weight: 400;
  line-height: 1.25em;
  letter-spacing: 0.025em;
  color: #333;
  background: #f7f7f7;
}

.center {
  position: relative;
  top: 300px;
  left: calc(50%);
  transform: translate(-50%, -50%);
}

.pic {
  width: 4rem;
  height: 4rem;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
}

.contact {
  position: relative;
  margin-bottom: 1rem;
  padding-left: 5rem;
  height: 4.5rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .pic {
    position: absolute;
    left: 0;
  }

  .name {
    font-weight: 500;
    margin-bottom: 0.125rem;
  }

  .message,
  .seen {
    font-size: 0.9rem;
    color: #999;
  }

  .badge {
    box-sizing: border-box;
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    text-align: center;
    font-size: 0.9rem;
    padding-top: 0.125rem;
    border-radius: 1rem;

    top: 0;
    left: 2.5rem;
    background: #333;
    color: white;
  }
}

.contacts {
  h2 {
    margin: 0.5rem 0 1.5rem 5rem;
  }

  .fa-bars {
    position: absolute;
    left: 2.25rem;

    color: #999;
    transition: color 200ms;

    &:hover {
      color: #666;
    }
  }

  .contact:last-child {
    margin: 0;
  }

  &:hover {
    transform: translate(-23rem, -50%);
  }
}

.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 24rem;
  height: 38rem;
  z-index: 2;
  box-sizing: border-box;
  border-radius: 1rem;

  background: white;
  box-shadow:
    0 0 8rem 0 rgba(black, 0.1),
    0rem 2rem 4rem -3rem rgba(black, 0.5);

  .contact.bar {
    flex-basis: 3.5rem;
    flex-shrink: 0;
    margin: 1rem;
    box-sizing: border-box;
  }

  .messages {
    min-height: 447px;
    padding: 1rem;
    background: #f7f7f7;
    flex-shrink: 2;
    overflow-y: auto;

    box-shadow:
      inset 0 2rem 2rem -2rem rgba(black, 0.05),
      inset 0 -2rem 2rem -2rem rgba(black, 0.05);

    .time {
      font-size: 0.8rem;
      background: #eee;
      padding: 0.25rem 1rem;
      border-radius: 2rem;
      color: #999;
      width: fit-content;
      margin: 0 auto;
    }

    .message {
      box-sizing: border-box;
      padding: 0.5rem 1rem;
      margin: 1rem;
      background: #fff;
      border-radius: 1.125rem 1.125rem 1.125rem 0;
      min-height: 2.25rem;
      width: fit-content;
      max-width: 66%;

      box-shadow:
        0 0 2rem rgba(black, 0.075),
        0rem 1rem 1rem -1rem rgba(black, 0.1);

      &.chat-user {
        margin: 1rem 1rem 1rem auto;
        border-radius: 1.125rem 1.125rem 0 1.125rem;
        background: #333;
        color: white;
      }

      .typing {
        display: inline-block;
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0rem;
        box-sizing: border-box;
        background: #ccc;
        border-radius: 50%;

        &.typing-1 {
          animation: typing 3s infinite;
        }

        &.typing-2 {
          animation: typing 3s 250ms infinite;
        }

        &.typing-3 {
          animation: typing 3s 500ms infinite;
        }
      }
    }
  }

  .input {
    box-sizing: border-box;
    flex-basis: 4rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 0.5rem 0 1.5rem;

    i {
      font-size: 1.5rem;
      margin-right: 1rem;
      color: #666;
      cursor: pointer;
      transition: color 200ms;

      &:hover {
        color: #333;
      }
    }

    input {
      border: none;
      background-image: none;
      background-color: white;
      padding: 0.5rem 1rem;
      margin-right: 1rem;
      border-radius: 1.125rem;
      flex-grow: 2;
      box-shadow:
        0 0 1rem rgba(black, 0.1),
        0rem 1rem 1rem -1rem rgba(black, 0.2);

      font-family:
        Red hat Display,
        sans-serif;
      font-weight: 400;
      letter-spacing: 0.025em;

      &:placeholder {
        color: #999;
      }
    }
  }
}

.chat-time-chat-leader {
  right: -40px;
  position: absolute;
  color: darkslateblue;
}

.chat-time-chat-user {
  left: -40px;
  position: absolute;
  color: darkslateblue;
}

.el-tabs--card {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}
.el-tab-pane {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

@keyframes typing {
  0%,
  75%,
  100% {
    transform: translate(0, 0.25rem) scale(0.9);
    opacity: 0.5;
  }

  25% {
    transform: translate(0, -0.25rem) scale(1);
    opacity: 1;
  }
}
</style>

<style scoped>
/deep/.itinerary .is-disabled * {
  color: blue !important;
}
</style>
